import { render, staticRenderFns } from "./RemoveDeclarationDialog.vue?vue&type=template&id=63d81341&scoped=true&"
import script from "./RemoveDeclarationDialog.vue?vue&type=script&lang=ts&"
export * from "./RemoveDeclarationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveDeclarationDialog.vue?vue&type=style&index=0&id=63d81341&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d81341",
  null
  
)

export default component.exports